import { Loader } from '@googlemaps/js-api-loader';

const initFormMap = async (mapGroup) => {
    const loader = new Loader({
        apiKey: 'AIzaSyAxYcC10bTXoApNU0BMInur6NY_YHkGUFc',
        version: 'weekly',
        libraries: ['places'],
    });

    const mapEl = mapGroup.querySelector('.js-map');
    const latInput = mapGroup.querySelector('.js-map-lat');
    const lngInput = mapGroup.querySelector('.js-map-lng');
    const addressInput = mapGroup.querySelector('.js-map-address');
    const readOnly = mapEl.dataset.readonly;

    if (!mapEl || !latInput || !lngInput || !addressInput) {
        return;
    }

    await loader.load();

    const geocoder = new google.maps.Geocoder();

    const { mapLat, mapLng } = mapEl.dataset;
    const center = {
        lat: parseFloat(mapLat) || 37.7749,
        lng: parseFloat(mapLng) || -122.4194,
    };

    const map = new google.maps.Map(mapEl, {
        zoom: 12,
        center,
        backgroundColor: '#c9eb94',
        disableDefaultUI: true,
        mapId: 'cc814f174db11922cbc6efa8',
    });

    const placeSearchInput = mapGroup.querySelector('.js-map-search');
    const searchBox = new google.maps.places.SearchBox(placeSearchInput);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(placeSearchInput);

    // Bias search results to current map bounds
    map.addListener('bounds_changed', () => {
        searchBox.setBounds(map.getBounds());
    });

    let markers = [];

    if (readOnly) {
        const marker = new google.maps.Marker({
            map,
            position: {
                lat: center.lat,
                lng: center.lng,
            },
        });
        map.zoom = 16;
        markers.push(marker);
    }

    // Function to update inputs and place a marker
    const updateMarkerAndInputs = (location, address = '') => {
        latInput.value = location.lat ? location.lat : location.lat();
        lngInput.value = location.lng ? location.lng : location.lng();
        addressInput.value = address;

        // Remove old markers
        markers.forEach((marker) => marker.setMap(null));
        markers = [];

        // Add new marker
        const marker = new google.maps.Marker({
            map,
            position: location,
        });
        markers.push(marker);
    };

    // Handle search box selection
    searchBox.addListener('places_changed', () => {
        const places = searchBox.getPlaces();
        if (!places || places.length === 0) return;

        const bounds = new google.maps.LatLngBounds();

        places.forEach((place) => {
            if (!place.geometry || !place.geometry.location) return;

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            const location = { lat, lng };

            updateMarkerAndInputs(
                location,
                place.formatted_address
            );

            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }
        });

        map.fitBounds(bounds);
    });

    // Handle map clicks
    map.addListener('click', (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        const location = { lat, lng };

        geocoder.geocode({ location }, (results, status) => {
            const address = status === 'OK' && results[0] ? results[0].formatted_address : '';
            updateMarkerAndInputs(location, address);
        });
    });
	
	updateMarkerAndInputs(center, null);
};

export default initFormMap;
